import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { Modal } from "@/shared/ui/modal"
import { closeInspectInvitationModal, selectCurrentInvitation, selectInspectInvitationModalOpen } from "../../model"

export const InspectInvitationModal = () => {
    const dispatch = useAppDispatch()
    const isOpen = useAppSelector(selectInspectInvitationModalOpen)
    const invitation = useAppSelector(selectCurrentInvitation)

    const handleClose = () => {
        dispatch(closeInspectInvitationModal())
    }

    return (
        <Modal
            isOpen={isOpen}
            title={(
                <div>
                    Приглашение в группу<br />
                    {invitation.group.name}
                </div>
            )}
            onRequestClose={handleClose}       
        >
            <div className='w-full flex items-center justify-center'>
                <img src={invitation.link} alt='QR' className='object-contain w-[80%] h-[100%]' />
            </div>
            <div className="w-full flex">
                <button onClick={handleClose} className="form_cancel_button">
                    Закрыть
                </button>
            </div>
        </Modal>
    )
}